import pixzzi from "../../../img/pixzzi.png";
import "./Projectrightimage.css";

const Projectimage = () => {
  return <img src={pixzzi} className="photossss  reveal fade-right" />;
};

export default Projectimage;
